import startCase from "lodash/startCase";
import ValueParameter from "views/logic/parameters/ValueParameter";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
const newParameterState = (parameterName) => new ValueParameter(parameterName, startCase(parameterName), "", "any", "", false, ParameterBinding.empty());
export default newParameterState;
